import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/utils/amplitude";
import Err from "@Broker/js/routes/error";
import { UPDATE_APP_DEAL_STATUS, SET_APPLICATION_STATUS } from "../../store/application-actions";
import { UPDATE_SUBMISSIONS_HISTORY_AFTER_APPLICATION_COMPLETE } from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import { CURRENT_APPLICATION, CURRENT_APPLICATION_SUB_STATUS } from "../../store/application-getters";
import { mapActions, mapGetters, mapState } from "vuex";
import ConfirmSubmissionModal from "./confirm-submission-modal.vue";
import { ENUM_FILOGIX_STATUS } from "@Shared/js/enum";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
export default defineComponent({
  name: "CompleteApplicationDropdown",
  components: {
    ConfirmSubmissionModal
  },
  props: {
    applicationId: {
      type: [Number, String],
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      completeStatus: "",
      completingApplication: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), mapState("ApplicationStore", {
    submissionHistory: state => state.submissionHistory,
    filogixSubmissions(state) {
      var _state$filogix$submis;
      const submissionByApplication = (_state$filogix$submis = state.filogix.submissions.byApplication) == null ? void 0 : _state$filogix$submis[this.applicationId];
      if (isEmpty(submissionByApplication)) return {
        byId: {},
        allIds: []
      };
      return submissionByApplication;
    }
  })), mapGetters("ApplicationStore", [CURRENT_APPLICATION_SUB_STATUS, CURRENT_APPLICATION])), {}, {
    applicationStatus() {
      return this.CURRENT_APPLICATION.applicationStatus;
    },
    applicationCompleted() {
      return this.applicationStatus === "completed";
    },
    lenderSubmissions() {
      const submissions = this.submissionHistory.byId || {};
      return _Object$values(submissions);
    },
    acceptedLenderSubmissions() {
      var _context;
      return _filterInstanceProperty(_context = this.lenderSubmissions).call(_context, ({
        status
      }) => status === ENUM_FILOGIX_STATUS.accepted);
    },
    declinedLenderSubmissions() {
      var _context2;
      return _filterInstanceProperty(_context2 = this.lenderSubmissions).call(_context2, ({
        status
      }) => status === ENUM_FILOGIX_STATUS.declined);
    },
    hasLenderSubmissions() {
      return this.lenderSubmissions.length > 0;
    },
    hasAcceptedSubmissions() {
      return this.acceptedLenderSubmissions.length > 0;
    },
    hasDeclinedSubmissions() {
      return this.declinedLenderSubmissions.length > 0;
    },
    hasFilogixSubmissions() {
      return this.filogixSubmissions.allIds.length > 0;
    },
    disableCompleteApplication() {
      return this.applicationCompleted && this.CURRENT_APPLICATION_SUB_STATUS === "declined";
    }
  }),
  mounted() {
    this.initFinastraDropdown();
  },
  updated() {
    this.initFinastraDropdown();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [UPDATE_APP_DEAL_STATUS, SET_APPLICATION_STATUS, UPDATE_SUBMISSIONS_HISTORY_AFTER_APPLICATION_COMPLETE])), {}, {
    initFinastraDropdown() {
      this.$nextTick(() => {
        $(".complete-app.split").tooltip({
          boundary: "window",
          reference: "parent"
        });
      });
    },
    async handleCloseDeal(status) {
      this.completeStatus = status;
      const isCancelledStatus = status === ENUM_FILOGIX_STATUS.cancelled;
      if (status === ENUM_FILOGIX_STATUS.declined && this.hasDeclinedSubmissions) {
        return this.$refs.confirmSubmissionModal.$showModal();
      } else if (status === ENUM_FILOGIX_STATUS.declined && !this.hasDeclinedSubmissions) {
        showToast("error", "completeApplicationRequirementsForDeclined");
      } else {
        if (this.hasAcceptedSubmissions || this.hasLenderSubmissions && isCancelledStatus || this.applicationCompleted) {
          return this.$refs.confirmSubmissionModal.$showModal();
        }
        if (this.hasFilogixSubmissions || isCancelledStatus) return this.submitCloseDeal(status);
        showToast("error", "completeApplicationRequirements");
      }
    },
    async submitCloseDeal(status) {
      const submitButton = $(this.$refs.completeApplication);
      try {
        this.completingApplication = true;
        submitButton.animateButton().animate("start");
        await this.UPDATE_APP_DEAL_STATUS({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          status
        });
        await submitButton.animateButton().animate("finish");
        this.UPDATE_SUBMISSIONS_HISTORY_AFTER_APPLICATION_COMPLETE({
          applicationId: this.applicationId,
          completeStatus: status,
          applicationCompleted: this.applicationCompleted
        });
        this.SET_APPLICATION_STATUS({
          submissionStatus: status
        });
        showToast("success", "applicationUpdated");
        Amplitude.logEvent("Applications - application marked complete", {
          clientUsername: this.clientUsername,
          completeStatus: status
        });
        this.$refs.confirmSubmissionModal.$hideModal();
      } catch (e) {
        Err.handle(e);
        submitButton.animateButton().animate("finish", "failed");
      } finally {
        this.completingApplication = false;
      }
    },
    showDropdownOption(status) {
      var _context3;
      return !this.applicationCompleted || !_includesInstanceProperty(_context3 = [this.CURRENT_APPLICATION_SUB_STATUS, "declined", "cancelled"]).call(_context3, status);
    }
  })
});